@if (replacingOperatorWithRuleForm !== null && replacingOperatorWithRule !== null) {
  <h3 mat-dialog-title i18n>
    Editing
    <eas-editor-eligibility-operator-title [operator]="replacingOperatorWithRule.operator">
    </eas-editor-eligibility-operator-title>
  </h3>
  <mat-dialog-content>
    <form [formGroup]="replacingOperatorWithRuleForm">
      <div class="form-container">
        <ng-container [formGroup]="getFormGroup('operator')">
          <mat-form-field appearance="outline">
            <mat-label i18n>Name</mat-label>
            <input matInput type="text" formControlName="name">
          </mat-form-field>
          <mat-radio-group formControlName="affirmative" style="padding-bottom: 15px">
            <mat-radio-button [value]="true" style="padding-right: 15px" i18n>Affirmative</mat-radio-button>
            <mat-radio-button [value]="false" style="padding-right: 15px" i18n>Negative</mat-radio-button>
          </mat-radio-group>
          @if (getOperatorFormControl('function')) {
            <mat-form-field appearance="outline">
              <mat-label i18n>Child rules connected by</mat-label>
              <mat-select id="operator-function" formControlName="function">
                @for (option of functions; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (getOperatorFormControl('hideNestedDescriptions')) {
            <mat-checkbox
              id="hide-nested-descriptions"
              formControlName="hideNestedDescriptions"
              i18n
              >
            Hide nested descriptions
          </mat-checkbox>
          }
        </ng-container>
        @if (getFormGroup('rule')) {
          <ng-container [formGroup]="getFormGroup('rule')">
            <mat-form-field appearance="outline">
              <mat-label i18n>Rule</mat-label>
              <mat-select id="rule-class-name" formControlName="ruleClassName">
                @for (option of rules; track option) {
                  <mat-option [value]="option.className">
                    {{ option.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @switch (getRuleFormControl('ruleClassName').value) {
              @case ('HasRole') {
                <eas-editor-eligibility-rule-form-has-role
                  [formGroup]="getRuleFormGroup('hasRole')"
                  >
                </eas-editor-eligibility-rule-form-has-role>
              }
              @case ('HasDateUserField') {
                <eas-editor-eligibility-rule-form-has-date-user-field
                  [formGroup]="getRuleFormGroup('hasDateUserField')"
                  >
                </eas-editor-eligibility-rule-form-has-date-user-field>
              }
              @case ('HasDiscreteUserField') {
                <eas-editor-eligibility-rule-form-has-discrete-user-field
                  [formGroup]="getRuleFormGroup('hasDiscreteUserField')"
                  >
                </eas-editor-eligibility-rule-form-has-discrete-user-field>
              }
              @case ('HasStringUserField') {
                <eas-editor-eligibility-rule-form-has-string-user-field
                  [formGroup]="getRuleFormGroup('hasStringUserField')"
                  >
                </eas-editor-eligibility-rule-form-has-string-user-field>
              }
              @case ('HasRelation') {
                <eas-editor-eligibility-rule-form-has-relation
                  [formGroup]="getRuleFormGroup('hasRelation')"
                  >
                </eas-editor-eligibility-rule-form-has-relation>
              }
              @case ('HasBookingItem') {
                <eas-editor-eligibility-rule-form-has-booking-item
                  [formGroup]="getRuleFormGroup('hasBookingItem')"
                  >
                </eas-editor-eligibility-rule-form-has-booking-item>
              }
              @case ('HasBookingOption') {
                <eas-editor-eligibility-rule-form-has-booking-option
                  [formGroup]="getRuleFormGroup('hasBookingOption')"
                  >
                </eas-editor-eligibility-rule-form-has-booking-option>
              }
              @case ('HasBookingType') {
                <eas-editor-eligibility-rule-form-has-booking-type
                  [formGroup]="getRuleFormGroup('hasBookingType')"
                  >
                </eas-editor-eligibility-rule-form-has-booking-type>
              }
              @case ('HasEvent') {
                <eas-editor-eligibility-rule-form-has-event
                  [formGroup]="getRuleFormGroup('hasEvent')"
                  >
                </eas-editor-eligibility-rule-form-has-event>
              }
              @case ('HasEventCount') {
                <eas-editor-eligibility-rule-form-has-event-count
                  [formGroup]="getRuleFormGroup('hasEventCount')"
                  >
                </eas-editor-eligibility-rule-form-has-event-count>
              }
              @case ('IsRawOperator') {
                <eas-editor-eligibility-rule-form-is-raw-operator
                  [formGroup]="getRuleFormGroup('isRawOperator')"
                  >
                </eas-editor-eligibility-rule-form-is-raw-operator>
              }
            }
          </ng-container>
        }
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" i18n>Discard</button>
    <button mat-flat-button color="primary" [disabled]="replacingOperatorWithRuleForm.invalid" (click)="onSubmit()" i18n>Apply</button>
  </mat-dialog-actions>
}
